module.exports = __webpack_public_path__ + "Termo_de_Uso_de_Imagem_para_MENORES.pdf?0712f946fc325523110d7d71387edfc5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/Termo_de_Uso_de_Imagem_para_MENORES.pdf
// module id = 89
// module chunks = 0